import logo from './logo.png';
import agent from './agent.png';
import book from './book.png';
import consentik from './consentik.png';
import synctrack from './synctrack.png';
import tiktok from './tiktok.png';
import chat from './omega_chat.png';
import edd from './edd-logo.png';
import age from './age-logo.jpg';

export const dashboardImage = {
  logo,
  agent,
  book,
  consentik,
  synctrack,
  tiktok,
  chat,
  edd,
  age,
};
